import * as React from 'react';
import { withRouter } from 'react-router-dom';
import { getAdminConfigTableItem } from '@src/app/_global/utility/adminConfigUtils';

const PageIntro = (props: any) => {
  let pageIntroTable = getAdminConfigTableItem(
    props.adminConfig,
    props.clientConfig,
    'PageIntro',
  );
  let currentRouteArray = props.location.pathname.split('/');
  let routeIndex = currentRouteArray.length - 1; 
  let currentRoute = currentRouteArray[routeIndex];
  while (!isNaN(currentRoute.substring(0, 1))) {
    routeIndex = routeIndex - 1;
    currentRoute = currentRouteArray[routeIndex];
  }
  let pageIntro;
  if (pageIntroTable.PageIntroductions) {
    pageIntro = pageIntroTable.PageIntroductions.find(intro => {
      return intro.route === currentRoute || 
        intro.altRoute === currentRoute || 
        intro.altRoute2 === currentRoute || 
        intro.altRoute3 === currentRoute;
    });
  }
  function createMarkup(nodeItem: any) {
    return {__html: nodeItem };
}
  return (
    <div className="page-intro-ct">
      {pageIntro && !pageIntro.hideLabel && (
      <div className="page-intro-label">{pageIntro.label}</div>
      )} 
      <span className="page-intro-desc" dangerouslySetInnerHTML={createMarkup(pageIntro ? pageIntro.description : '')}>
      </span>
    </div>
  );
};
export default withRouter(PageIntro);
